// Create this in a new file: nodeTypes.js
import EditableNode from './EditableNode';

const nodeTypes = {
  editableNode: EditableNode,
  input: EditableNode, // Using same component for input nodes
  default: EditableNode // Fallback type
};

export default nodeTypes;